<template>
  <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
    <slot />
  </transition>
</template>

<script>
  /**
   * @displayName ExpandTransition
   */
  export default {
    name: 'DExpandTransition',
    parent: true,
    methods: {
      enter(element) {
        const { width } = getComputedStyle(element);

        element.style.width = width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const { height } = getComputedStyle(element);

        element.style.width = null;
        element.style.position = 'initial';
        element.style.visibility = 'visible';
        element.style.height = 0;

        this.forceRepaint(element);

        setTimeout(() => {
          element.style.height = height;
        });
      },

      afterEnter(element) {
        element.style.height = 'auto';
      },

      leave(element) {
        const { height } = getComputedStyle(element);

        element.style.height = height;
        this.forceRepaint(element);

        setTimeout(() => {
          element.style.height = 0;
        });
      },

      forceRepaint(element) {
        // eslint-disable-next-line no-unused-expressions
        getComputedStyle(element).height;
      },
    },
  };
</script>